import script from "./addOrEditPlan.vue?vue&type=script&lang=ts&setup=true"
export * from "./addOrEditPlan.vue?vue&type=script&lang=ts&setup=true"

import "./addOrEditPlan.vue?vue&type=style&index=0&id=2a56ed9a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a56ed9a"]])

export default __exports__